<div class="flex flex-col min-h-screen">

    <div class="mb-6">
        <app-header [id]="id"></app-header>
    </div>


    <div class="flex-grow lg:pt-2 bg-gray-20 lg:border-b border-gray-300 ">
        <div class=" container mx-auto lg:px-16 lg:mb-20 px-3 space-y-4">

            <h2 class="text-2xl font-bold font-mulish lg:mt-6">Donate Now</h2>

            <p [innerHTML]="cashDonationText ?? '' | sanitizeHtmlText"></p>

            <div class="flex flex-col lg:flex-row gap-4 ">


                <div class="w-full lg:w-2/3 space-y-4 sm:space-y-14 lg:space-y-4"
                    [ngClass]="{ 'hidden': mobileStep !== 1 }">


                    <div class="flex flex-col sm:flex-row sm:items-start sm:gap-4">

                        <div class="sm:flex-[3] mt-2 min-w-[200px]">
                            <label class="block text-gray-500 text-sm font-mulish font-semibold tracking-wide mt-4">
                                Select an Amount to donate
                            </label>
                            <div
                                class="flex flex-wrap justify-between items-center border-2 border-primary-500 rounded-xl overflow-hidden h-[47px] mt-1 w-full">
                                <button *ngFor="let amount of amounts" (click)="selectAmount(amount)"
                                    class="flex-1 text-center text-sm sm:text-base px-2 sm:px-4 py-2 rounded-lg  font-medium focus:outline-none transition h-full min-w-[60px]"
                                    [ngClass]="{
                            'bg-primary-500 !text-[var(--p-text-color-primary)]': selectedAmount === amount,
                            'text-primary-500 hover:bg-gray-100': selectedAmount !== amount
                            }">
                                    ${{ amount }}
                                </button>
                            </div>
                        </div>

                        <div class="sm:flex-[2] mt-6 lg:mt-6 min-w-[180px]">
                            <label class="block text-gray-500 text-sm font-mulish font-semibold tracking-wide">
                                Other Amount
                            </label>
                            <input pInputText class="w-full mt-1" placeholder="$" [(ngModel)]="otherAmount"
                                (input)="onValidateAmount($event)"
                                (ngModelChange)="selectedAmount = null; updateTotalAmount()" name="customAmount" />
                            <ng-container *ngIf="!isValidAmount">
                                <small class="text-red-500 block min-h-[1rem]">
                                    Only whole numbers are allowed.
                                </small>
                            </ng-container>
                        </div>

                    </div>

                    <div class="flex flex-col md:flex-row gap-2 w-full mt-4">
                        <div class="flex-1 flex flex-col mt-2">
                            <label class="block text-gray-500 text-sm font-mulish font-semibold tracking-wide">Display
                                Donor Name As
                                *
                            </label>
                            <input pInputText class="w-full text-sm" [style]="{ width: '100%' }"
                                [ngModel]="donorInputValue" (ngModelChange)="onInputDonorNameChange($event)"
                                (blur)="onBlurUpdateDonor()" [disabled]="isAnonymous" />

                            <ng-container *ngIf="showDonorNameAlert && !isAnonymous">
                                <small class="text-red-500 block min-h-[1rem]">
                                    Please enter the donor's name or check donate anonymously
                                </small>
                            </ng-container>

                            <div class="flex items-center gap-2 mb-2 lg:mb-6 mt-2">
                                <input type="checkbox" id="isAnonymous" [(ngModel)]="isAnonymous"
                                    (change)="onAnonymousChange()" />
                                <label for="coverFee" class="text-gray-500 text-sm  ">
                                    I'd like to remain anonymous as a donor
                                </label>
                            </div>
                        </div>

                    </div>

                    <div class="mb-4">
                        <label
                            class="block text-gray-600 text-sm font-mulish font-semibold tracking-wide">{{cashDonationConfigSignal()?.commentHeading}}</label>
                        <textarea pInputTextarea rows="4" [(ngModel)]="comment"
                            class="w-full border border-gray-300 p-2 rounded-md mb-6 lg:mb-2"></textarea>
                    </div>

                    <div class="mt-10 flex gap-2 md:hidden">

                        <button pButton type="button" label="Cancel" [routerLink]="['/auction', id]"
                            class="!bg-white !border !outline-custom-blue !text-custom-blue  px-6 py-2 font-medium w-1/2 text-base"
                            [rounded]="true"></button>


                        <button pButton
                            class="!bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] rounded-m w-full relative flex items-center justify-center w-1/2"
                            [rounded]="true" (click)="onNextStepMobile()"
                            [disabled]="!isAnonymous && donorInputValue.length === 0">
                            <i class="pi pi-angle-double-right left-3">
                            </i>
                            <span class="font-semibold text-white text-center w-full text-base">
                                Next
                            </span>
                        </button>

                    </div>

                    <div class=" hidden md:flex mt-4 w-full">
                        <button pButton
                            class="!bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] mt-6 rounded-m w-full relative flex items-center justify-center"
                            [disabled]="!isAnonymous && donorInputValue.length === 0" [rounded]="true"
                            (click)="isAuthenticated().isAuthenticated ? embeddedPaymentLoad() : openLoginModal() ">
                            <span class="pi pi-credit-card !text-[var(--p-text-color-secondary)] text-xs absolute left-3"></span>
                            <span class="font-mulish text-xs md:text-base !text-[var(--p-text-color-secondary)] font-semibold whitespace-nowrap">
                                Donate Now
                            </span>
                        </button>
                    </div>

                    <app-embedded-payment [token]=" token" [(visible)]="visibleEmbedded"></app-embedded-payment>
                    <div *ngIf="showWinningBidText()">
                        <ng-container *ngTemplateOutlet="winningBidText"></ng-container>
                    </div>

                </div>

                <div class="w-full lg:w-1/3 p-4 rounded-xl " [ngClass]="{ 'hidden': isMobile && mobileStep !== 2 }">
                    <h2 class=" block md:hidden text-2xl font-bold font-mulish">Donate Now</h2>
                    <h2 class="text-2xl font-semibold mb-4 lg:mt-4 px-3" style="color: var(--p-primary-500);">Summary</h2>
                    <ng-container *ngTemplateOutlet="summaryContent" class="px-3"></ng-container>

                </div>
            </div>
        </div>
    </div>


    <ng-template #summaryContent>
        <div class="text-sm space-y-6  rounded-lg mb-18 mt-8 bg-white shadow-md rounded-lg px-3">
            <p class="font-mulish font-medium text-[16px] mb-8">Please review the information below and click Edit to
                make
                any
                changes.</p>

            <div class="mt-10 pt-2 border-t border-gray-200">

                <p class="text-sm font-semibold font-mulish pt-2" style="color: var(--panorama-gray);"> Donor Name:
                    <span class="font-semibold ml-10 lg:ml-10 font-mulish text-black text-lg">
                        {{ selectedDonor }}
                    </span>
                </p>
            </div>
            <div class="mt-10 pt-6 border-t border-gray-200">
                <p class="text-sm font-semibold font-mulish" style="color: var(--panorama-gray);">
                    Donation Amount:
                    <span *ngIf="isValidAmount" class="font-semibold ml-10 font-mulish text-black text-lg">
                        ${{ (otherAmount ?? selectedAmount)}} {{currency()}}
                    </span>
                </p>

            </div>
            <p class="text-xl font-bold font-mulish pt-2 mb-8">
                Total:
                <span *ngIf="isValidAmount" class="font-semibold ml-24 font-mulish text-black text-lg">
                    {{ totalAmount | currency:'USD'}} {{currency()}}
                </span>
            </p>
        </div>
        <div *ngIf="isMobile && mobileStep !== 1">
            <ng-container *ngTemplateOutlet="SummaryButtons"></ng-container>
        </div>
        <div class="block md:hidden mt-4" *ngIf="showWinningBidText()">
            <ng-container *ngTemplateOutlet="winningBidText"></ng-container>
        </div>
    </ng-template>

    <ng-template #winningBidText>
        <div class="mb-10 ">
            <p class="text-xs text-gray-700  font font-mulish  text-center">
               Your donation is being made to <a href="https://frontstreamglobalfund.org/"
                class="text-blue-500 underline">FrontStream Global Fund</a>
            (tax ID 26-3265577), a 501c3 nonprofit organization, which will send your donation to
            {{homePageSignal()?.orgName}} (tax ID {{homePageSignal()?.taxId}}) on your behalf.
            </p>
        </div>
    </ng-template>

    <ng-template #SummaryButtons>
        <div class="mt-10 flex gap-2 md:hidden">

            <button pButton type="button"
                class="!bg-white !border !border-custom-blue !text-custom-blue px-4 py-2 font-medium text-base flex-[1] !rounded-full flex justify-end items-center"
                (click)="mobileStep = 1">
                <i class="pi pi-angle-double-left text-xl"></i>
            </button>

            <button pButton
                class="!bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] rounded-m w-full relative flex-[4] flex items-center justify-center gap-2"
                [rounded]="true"
                (click)="isAuthenticated().isAuthenticated ? embeddedPaymentLoad() : openLoginModal() ">
                <i class="pi pi-credit-card text-white text-xs left-3">
                </i>
                <span class="font-semibold text-white text-center w-full text-base">
                    Donate Now
                </span>
            </button>
        </div>
        <app-embedded-payment [token]="token" [(visible)]="visibleEmbedded"></app-embedded-payment>
    </ng-template>


    <div>
        <app-footer></app-footer>
    </div>
</div>